module.exports = __webpack_public_path__ + "static/media/courses-ellipse-icon.691d8647.png";